import React, { useState, useEffect } from "react";
import Gallery from 'react-image-gallery'; // Import the gallery component
import 'react-image-gallery/styles/css/image-gallery.css';
import { useParams } from "react-router-dom";
import { fetchData } from "../../Components/common/utils";
import MainLoader from "../../Components/MainLoader";
import BookingModal from "../../Components/BookingModal";
function VariantDetail() {
    const [data, setData] = useState([]);
    const [imagesList, setImagesList] = useState([]);
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    useEffect(() => {
        const fetchApiData = async () => {
            const url = "api/specification/" + id;
            const result = await fetchData(url);
            if (result && result.data) {
                const images = result.data.media.map(item => ({
                    original: item.original_url,
                    thumbnail: item.original_url
                }));
                setImagesList(images)
                setData(result.data);
            }
            setLoading(false);
        };
        fetchApiData();
    }, [id]);
    const responsive = [
        {
            breakpoint: 1024, // Tablets and large mobile devices
            settings: {
                slidesToShow: 3,  // Display 3 images at a time on medium screens
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768, // Small devices (e.g. mobile phones)
            settings: {
                slidesToShow: 1,  // Show 1 image at a time on mobile screens
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480, // Very small screens
            settings: {
                slidesToShow: 1,  // Show 1 image at a time on very small screens
                slidesToScroll: 1,
            },
        },
    ];
    return (
        <div className="container my-5">
            {loading && <MainLoader />}
            <h3>{data?.title}</h3>
            <div className="row mt-3 bg-light p-2">
                <div className="col-md-8 p-2">
                    <Gallery items={imagesList} autoPlay={false} responsive={responsive} />
                </div>
                <div className="col-md-4">
                    <div className="rounded d-flex  align-items-center py-4 px-3">
                        <svg height="60px" width="60px" version="1.1" id="_x32_" viewBox="0 0 512 512" xmlSpace="preserve" fill="#000000">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <style type="text/css">
                                    {`
                                            .st0 {
                                                fill: #e4212b;
                                            }
                                            `}
                                </style>
                                <g>
                                    <path className="st0" d="M255.996,74.939C114.838,74.939,0,189.784,0,330.942c0,19.646,2.24,39.233,6.667,58.228 c0.509,2.18,1.093,4.202,1.745,6.074c7.714,24.672,30.948,41.817,56.865,41.817h381.364c24.104,0,45.847-14.785,55-36.679 c1.108-2.18,2.03-4.599,2.734-7.296c0.27-1.026,0.689-2.741,1.318-5.528c4.179-18.478,6.307-37.54,6.307-56.617 C512,189.784,397.155,74.939,255.996,74.939z M475.763,380.811c-1.026,4.547-1.356,5.64-1.431,5.64l0.067-0.921 c-3.579,12.35-14.897,20.852-27.758,20.852H65.277c-12.831,0-24.119-8.456-27.729-20.77l0.21,1.416 c-0.045,0-0.33-1.026-1.214-4.816c-3.835-16.471-5.865-33.631-5.865-51.27c0-124.448,100.877-225.324,225.317-225.324 c124.44,0,225.324,100.876,225.324,225.324C481.321,348.08,479.396,364.767,475.763,380.811z"></path>
                                    <path className="st0" d="M267.569,297.207c-3.633-1.244-7.52-1.955-11.572-1.955c-19.707,0-35.683,15.976-35.683,35.69 c0,19.706,15.976,35.682,35.683,35.682c18.036,0,32.912-13.392,35.308-30.769c0.225-1.618,0.374-3.243,0.374-4.913 C291.679,315.288,281.59,302.015,267.569,297.207z"></path>
                                    <path className="st0" d="M399.716,194.787c-3.138-3.392-8.808-3.468-13.257-0.18l-123.594,91.004c2.696,0.412,5.378,1.049,8.014,1.955 c15.968,5.483,27.406,19.182,30.275,35.383l97.79-114.913C402.548,203.813,402.877,198.143,399.716,194.787z"></path>
                                    <path className="st0" d="M340.402,182.908c5.543,3.214,12.628,1.303,15.834-4.239c3.206-5.551,1.303-12.636-4.239-15.849 c-5.543-3.19-12.644-1.288-15.849,4.247C332.956,172.624,334.844,179.717,340.402,182.908z"></path>
                                    <path className="st0" d="M259.239,161.172c6.412,0,11.595-5.206,11.595-11.595c0-6.411-5.183-11.602-11.595-11.602 c-6.396,0-11.594,5.191-11.594,11.602C247.645,155.966,252.843,161.172,259.239,161.172z"></path>
                                    <path className="st0" d="M76.175,320.898c-6.726,0-12.209,5.468-12.209,12.209s5.482,12.194,12.209,12.194 c6.741,0,12.194-5.453,12.194-12.194S82.916,320.898,76.175,320.898z"></path>
                                    <path className="st0" d="M114.441,226.471c-5.542-3.206-12.643-1.289-15.849,4.254c-3.19,5.542-1.288,12.628,4.239,15.841 c5.558,3.206,12.658,1.296,15.864-4.247C121.886,236.776,119.984,229.677,114.441,226.471z"></path>
                                    <path className="st0" d="M166.497,162.82c-5.558,3.213-7.445,10.298-4.239,15.849c3.191,5.542,10.291,7.453,15.834,4.239 c5.543-3.19,7.445-10.299,4.254-15.841C179.141,161.531,172.04,159.629,166.497,162.82z"></path>
                                    <path className="st0" d="M404.038,226.471c-5.542,3.206-7.445,10.306-4.239,15.849c3.206,5.558,10.292,7.453,15.849,4.247 c5.542-3.213,7.445-10.299,4.239-15.841C416.696,225.182,409.595,223.265,404.038,226.471z"></path>
                                    <path className="st0" d="M433.144,335.062c6.412,0,11.595-5.184,11.595-11.587c0-6.412-5.183-11.61-11.595-11.61 c-6.411,0-11.594,5.198-11.594,11.61C421.55,329.878,426.733,335.062,433.144,335.062z"></path>
                                </g>
                            </g>
                        </svg>
                        <div className="ms-5">
                            <h6>MILEAGE (KM/LITER)</h6>
                            <p className="mb-0">{data?.mileage}</p>
                        </div>
                    </div>
                    <div className=" border-top rounded d-flex  align-items-center py-4 px-3">
                        <svg width="60px" height="60px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M2 4C2 2.89543 2.89543 2 4 2C5.10457 2 6 2.89543 6 4C6 4.83934 5.48296 5.55793 4.75 5.85462V11.25H11.25V5.85462C10.517 5.55793 10 4.83934 10 4C10 2.89543 10.8954 2 12 2C13.1046 2 14 2.89543 14 4C14 4.83934 13.483 5.55793 12.75 5.85462V11.25H16C16.964 11.25 17.6116 11.2484 18.0946 11.1835C18.5561 11.1214 18.7536 11.0142 18.8839 10.8839C19.0142 10.7536 19.1214 10.5561 19.1835 10.0946C19.2484 9.61157 19.25 8.96401 19.25 8V5.85462C18.517 5.55793 18 4.83934 18 4C18 2.89543 18.8954 2 20 2C21.1046 2 22 2.89543 22 4C22 4.83934 21.483 5.55793 20.75 5.85462V8.05199C20.75 8.95048 20.7501 9.6997 20.6701 10.2945C20.5857 10.9223 20.4 11.4891 19.9445 11.9445C19.4891 12.4 18.9223 12.5857 18.2945 12.6701C17.6997 12.7501 16.9505 12.75 16.052 12.75L12.75 12.75L12.75 18.1454C13.483 18.4421 14 19.1607 14 20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20C10 19.1607 10.517 18.4421 11.25 18.1454V12.75H4.75V18.1454C5.48296 18.4421 6 19.1607 6 20C6 21.1046 5.10457 22 4 22C2.89543 22 2 21.1046 2 20C2 19.1607 2.51704 18.4421 3.25 18.1454V5.85462C2.51704 5.55793 2 4.83934 2 4Z" fill="#da232c"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M17.25 15C17.25 14.5858 17.5858 14.25 18 14.25H20.2857C21.6612 14.25 22.75 15.3839 22.75 16.75C22.75 17.8285 22.0713 18.7624 21.1086 19.1077L22.6396 21.6084C22.8559 21.9616 22.7449 22.4234 22.3916 22.6396C22.0384 22.8559 21.5766 22.7449 21.3604 22.3916L19.4369 19.25H18.75V22C18.75 22.4142 18.4142 22.75 18 22.75C17.5858 22.75 17.25 22.4142 17.25 22V15ZM18.75 17.75H20.2857C20.8038 17.75 21.25 17.3169 21.25 16.75C21.25 16.1831 20.8038 15.75 20.2857 15.75H18.75V17.75Z" fill="#da232c"></path> </g></svg>
                        <div className="ms-5">
                            <h6>Transmission</h6>
                            <p className="mb-0">{data?.transmission}</p>
                        </div>
                    </div>
                    <div className=" border-top rounded d-flex  align-items-center py-4 px-3">
                        <svg fill="#e5202b" width="60px" height="60px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M522.267 910.508c16.962 0 30.72-13.758 30.72-30.72v-736.43c0-16.962-13.758-30.72-30.72-30.72H143.356c-16.962 0-30.72 13.758-30.72 30.72v736.43c0 16.962 13.758 30.72 30.72 30.72h378.911zm0 40.96H143.356c-39.583 0-71.68-32.097-71.68-71.68v-736.43c0-39.583 32.097-71.68 71.68-71.68h378.911c39.583 0 71.68 32.097 71.68 71.68v736.43c0 39.583-32.097 71.68-71.68 71.68zm388.62-678.049v500.265c0 49.412-40.054 89.467-89.467 89.467-49.443 0-89.498-40.054-89.498-89.467 0-11.311-9.169-20.48-20.48-20.48s-20.48 9.169-20.48 20.48c0 72.034 58.393 130.427 130.427 130.427 72.065 0 130.458-58.393 130.458-130.427V273.419c0-11.311-9.169-20.48-20.48-20.48s-20.48 9.169-20.48 20.48z"></path><path d="M731.92 779.436V368.648c0-11.311-9.169-20.48-20.48-20.48s-20.48 9.169-20.48 20.48v410.788c0 11.311 9.169 20.48 20.48 20.48s20.48-9.169 20.48-20.48z"></path><path d="M731.943 365.513v-34.499c0-49.414-40.053-89.467-89.467-89.467-49.415 0-89.477 40.054-89.477 89.467v34.499c0 11.311 9.169 20.48 20.48 20.48s20.48-9.169 20.48-20.48v-34.499c0-26.789 21.722-48.507 48.517-48.507 26.792 0 48.507 21.715 48.507 48.507v34.499c0 11.311 9.169 20.48 20.48 20.48s20.48-9.169 20.48-20.48zM942.5 254.981L767.785 80.266c-7.998-7.998-20.965-7.998-28.963 0s-7.998 20.965 0 28.963l174.715 174.715c7.998 7.998 20.965 7.998 28.963 0s7.998-20.965 0-28.963zM438.84 281.52c5.657 0 10.24-4.583 10.24-10.24V225.2c0-5.657-4.583-10.24-10.24-10.24H225.541a10.238 10.238 0 00-10.24 10.24v46.08c0 5.657 4.583 10.24 10.24 10.24H438.84zm0 40.96H225.541c-28.278 0-51.2-22.922-51.2-51.2V225.2c0-28.278 22.922-51.2 51.2-51.2H438.84c28.278 0 51.2 22.922 51.2 51.2v46.08c0 28.278-22.922 51.2-51.2 51.2z"></path><path d="M928.972 358.832h-48.978c-11.309 0-20.48-9.171-20.48-20.48V191.091c0-11.311-9.169-20.48-20.48-20.48s-20.48 9.169-20.48 20.48v147.261c0 33.931 27.509 61.44 61.44 61.44h48.978c11.311 0 20.48-9.169 20.48-20.48s-9.169-20.48-20.48-20.48z"></path></g></svg>
                        <div className="ms-5">
                            <h6>Fuel Type</h6>
                            <p className="mb-0">{data?.fuel_type}</p>
                        </div>
                    </div>
                    <div className=" border-top rounded d-flex  align-items-center py-4 px-3">
                        <svg fill="#f2232d" height="60px" width="60px" version="1.1" id="Layer_1" viewBox="0 0 512 512">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <g>
                                    <g>
                                        <polygon points="351.067,170.863 322.93,145.913 276.4,145.913 276.4,123.219 291.366,123.219 291.366,89.828 172.742,89.828 172.742,123.219 187.709,123.219 187.709,145.913 139.265,145.913 111.127,170.863 66.783,170.863 66.783,187.559 66.783,253.795 33.391,253.795 33.391,211.179 0,211.179 0,329.804 33.391,329.804 33.391,287.186 66.783,287.186 66.783,353.422 66.783,370.118 139.265,370.118 197.974,422.172 395.388,422.172 395.388,170.863" />
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <path d="M494.32,196.801l-4.858-8.131h-60.683v214.625h60.683l4.858-8.132c1.81-3.027,17.68-31.537,17.68-99.181 S496.13,199.829,494.32,196.801z" />
                                    </g>
                                </g>
                            </g>
                        </svg>
                        <div className="ms-5">
                            <h6>Engine</h6>
                            <p className="mb-0">{data?.engine}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-5 varient-detail">

                <div class="title-wrapper d-flex mb-30">
                    <h4 class="mb-0 flex-shrink-0"> Engine and Performance</h4>
                    <span class="spacer align-self-end ms-3"></span>
                </div>
                {/* <div style={{ overflow: 'scroll' }} className="teble-td-inherit">
                    <table class="table table-bordered rounded mt-3 ">
                        <tbody>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Engine Type</p>
                                        <p className="pb-0 mb-0">{data.engineperformance?.engine_type}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Engine Capacity</p>
                                        <p className="pb-0 mb-0">{data.engineperformance?.engine_capacity}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Power Output</p>
                                        <p className="pb-0 mb-0">{data.engineperformance?.power_output}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Torque</p>
                                        <p className="pb-0 mb-0">{data.engineperformance?.torque}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Transmission</p>
                                        <p className="pb-0 mb-0">{data.engineperformance?.transmission}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Fuel Efficiency</p>
                                        <p className="pb-0 mb-0">{data.engineperformance?.fuel_efficiency}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Acceleration (0-60 mph or 0-100 km/h)</p>
                                        <p className="pb-0 mb-0">{data.engineperformance?.acceleration}</p>
                                    </div>
                                </td>

                            </tr>

                        </tbody>
                    </table>
                </div> */}
                <div className="row gy-3 mt-3">
                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Engine Type</p>
                            <p className="mb-0">{data.engineperformance?.engine_type}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Engine Capacity</p>
                            <p className="mb-0">{data.engineperformance?.engine_capacity}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Power Output</p>
                            <p className="mb-0">{data.engineperformance?.power_output}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Torque</p>
                            <p className="mb-0">{data.engineperformance?.torque}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Transmission</p>
                            <p className="mb-0">{data.engineperformance?.transmission}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Fuel Efficiency</p>
                            <p className="mb-0">{data.engineperformance?.fuel_efficiency}</p>
                        </div>
                    </div>

                    <div className="col-12 col-md-6">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Acceleration (0-60 mph or 0-100 km/h)</p>
                            <p className="mb-0">{data.engineperformance?.acceleration}</p>
                        </div>
                    </div>

                </div>

                <div class="title-wrapper d-flex mb-30 mt-4">
                    <h4 class="mb-0 flex-shrink-0">Dimensions & Weight
                    </h4>
                    <span class="spacer align-self-end ms-3"></span>
                </div>
                {/* <div style={{ overflow: 'scroll' }} className="teble-td-inherit">
                    <table class="table table-bordered rounded mt-3 ">
                        <tbody >
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Length</p>
                                        <p className="pb-0 mb-0">{data?.diminsionweight?.length}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Width</p>
                                        <p className="pb-0 mb-0">{data?.diminsionweight?.width}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Height</p>
                                        <p className="pb-0 mb-0">{data?.diminsionweight?.height}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Wheelbase</p>
                                        <p className="pb-0 mb-0">{data?.diminsionweight?.wheel_base}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Ground Clearance</p>
                                        <p className="pb-0 mb-0">{data?.diminsionweight?.ground_clearance}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Kerb Weight</p>
                                        <p className="pb-0 mb-0">{data?.diminsionweight?.kerb_weight}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Cargo Capacity</p>
                                        <p className="pb-0 mb-0">{data?.diminsionweight?.cargo_capacity}</p>
                                    </div>
                                </td>

                            </tr>

                        </tbody>
                    </table>
                </div> */}
                <div className="row gy-3 mt-3">

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Length</p>
                            <p className="mb-0">{data?.diminsionweight?.length}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Width</p>
                            <p className="mb-0">{data?.diminsionweight?.width}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Height</p>
                            <p className="mb-0">{data?.diminsionweight?.height}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Wheelbase</p>
                            <p className="mb-0">{data?.diminsionweight?.wheel_base}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Ground Clearance</p>
                            <p className="mb-0">{data?.diminsionweight?.ground_clearance}</p>
                        </div>
                    </div>

                    <div className="col-md-6 col-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Kerb Weight</p>
                            <p className="mb-0">{data?.diminsionweight?.kerb_weight}</p>
                        </div>
                    </div>

                    <div className="col-12 col-md-12">
                        <div className="p-3 border rounded d-flex justify-content-between align-items-center">
                            <p className="mb-0 text-secondary">Cargo Capacity</p>
                            <p className="mb-0">{data?.diminsionweight?.cargo_capacity}</p>
                        </div>
                    </div>

                </div>

                <div class="title-wrapper d-flex mb-30 mt-4">
                    <h4 class="mb-0 flex-shrink-0"> Interior & Comfort
                    </h4>
                    <span class="spacer align-self-end ms-3"></span>
                </div>
                {/* <div style={{ overflow: 'scroll' }} className="teble-td-inherit">
                    <table class="table table-bordered rounded mt-3 ">
                        <tbody >
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Seating Capacity</p>
                                        <p className="pb-0 mb-0">{data?.interiorcomfort?.seating_capacity}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Upholstery</p>
                                        <p className="pb-0 mb-0">{data?.interiorcomfort?.upholstery}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Infotainment</p>
                                        <p className="pb-0 mb-0">{data?.interiorcomfort?.infotainment}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Climate Control</p>
                                        <p className="pb-0 mb-0">{data?.interiorcomfort?.climate_control}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Driver Assistance Features</p>
                                        <p className="pb-0 mb-0">{data?.interiorcomfort?.driver_assistance_features}</p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div> */}
                <div className="mt-3">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Seating Capacity</p>
                                    <p className="mb-0">{data?.interiorcomfort?.seating_capacity}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Upholstery</p>
                                    <p className="mb-0">{data?.interiorcomfort?.upholstery}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Infotainment</p>
                                    <p className="mb-0">{data?.interiorcomfort?.infotainment}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Climate Control</p>
                                    <p className="mb-0">{data?.interiorcomfort?.climate_control}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Driver Assistance Features</p>
                                    <p className="mb-0">{data?.interiorcomfort?.driver_assistance_features}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="title-wrapper d-flex mb-30 mt-4">
                    <h4 class="mb-0 flex-shrink-0">Safety Features
                    </h4>
                    <span class="spacer align-self-end ms-3"></span>
                </div>
                {/* <div style={{ overflow: 'scroll' }} className="teble-td-inherit">
                    <table class="table table-bordered rounded mt-3 ">
                        <tbody >
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Airbags</p>
                                        <p className="pb-0 mb-0">{data?.safetyfeature?.airbags}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Braking System</p>
                                        <p className="pb-0 mb-0">{data?.safetyfeature?.braking_system}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Crash Test Rating</p>
                                        <p className="pb-0 mb-0">{data?.safetyfeature?.crash_test_rating}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Security Features</p>
                                        <p className="pb-0 mb-0">{data?.safetyfeature?.Security_features}</p>
                                    </div>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div> */}
                <div className="mt-3">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Airbags</p>
                                    <p className="mb-0">{data?.safetyfeature?.airbags}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Braking System</p>
                                    <p className="mb-0">{data?.safetyfeature?.braking_system}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Crash Test Rating</p>
                                    <p className="mb-0">{data?.safetyfeature?.crash_test_rating}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Security Features</p>
                                    <p className="mb-0">{data?.safetyfeature?.Security_features}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="title-wrapper d-flex mb-30 mt-4">
                    <h4 class="mb-0 flex-shrink-0"> Exterior
                    </h4>
                    <span class="spacer align-self-end ms-3"></span>
                </div>
                {/* <div style={{ overflow: 'scroll' }} className="teble-td-inherit">
                    <table class="table table-bordered rounded mt-3 ">
                        <tbody >
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Headlights</p>
                                        <p className="pb-0 mb-0">{data?.exterior?.headlights}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Wheels/Tires</p>
                                        <p className="pb-0 mb-0">{data?.exterior?.wheels_tires}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Sunroof/Convertible</p>
                                        <p className="pb-0 mb-0">{data?.exterior?.sunroof}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Mirrors</p>
                                        <p className="pb-0 mb-0">{data?.exterior?.mirrors}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Exterior Colors</p>
                                        <p className="pb-0 mb-0">{data?.exterior?.exterior_colors}</p>
                                    </div>
                                </td>

                            </tr>

                        </tbody>
                    </table>
                </div> */}
                <div className="mt-3">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Headlights</p>
                                    <p className="mb-0">{data?.exterior?.headlights}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Wheels/Tires</p>
                                    <p className="mb-0">{data?.exterior?.wheels_tires}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Sunroof/Convertible</p>
                                    <p className="mb-0">{data?.exterior?.sunroof}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Mirrors</p>
                                    <p className="mb-0">{data?.exterior?.mirrors}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Exterior Colors</p>
                                    <p className="mb-0">{data?.exterior?.exterior_colors}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="title-wrapper d-flex mb-30 mt-4">
                    <h4 class="mb-0 flex-shrink-0">Technology & Connectivity
                    </h4>
                    <span class="spacer align-self-end ms-3"></span>
                </div>
                {/* <div style={{ overflow: 'scroll' }} className="teble-td-inherit">
                    <table class="table table-bordered rounded mt-3 ">
                        <tbody>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Navigation System</p>
                                        <p className="pb-0 mb-0">{data?.technologyconnectivity?.navigation_system}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Connectivity</p>
                                        <p className="pb-0 mb-0">{data?.technologyconnectivity?.connectivity}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Camera & Sensors</p>
                                        <p className="pb-0 mb-0">{data?.technologyconnectivity?.camera_sensors}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Keyless Entry</p>
                                        <p className="pb-0 mb-0">{data?.technologyconnectivity?.keyless_entry}</p>
                                    </div>
                                </td>
                            </tr>


                        </tbody>
                    </table>
                </div> */}
                <div className="mt-3">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Navigation System</p>
                                    <p className="mb-0">{data?.technologyconnectivity?.navigation_system}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Connectivity</p>
                                    <p className="mb-0">{data?.technologyconnectivity?.connectivity}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Camera &amp; Sensors</p>
                                    <p className="mb-0">{data?.technologyconnectivity?.camera_sensors}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Keyless Entry</p>
                                    <p className="mb-0">{data?.technologyconnectivity?.keyless_entry}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="title-wrapper d-flex mb-30 mt-4">
                    <h4 class="mb-0 flex-shrink-0">Fuel & Charging (if applicable)
                    </h4>
                    <span class="spacer align-self-end ms-3"></span>
                </div>
                {/* <div style={{ overflow: 'scroll' }} className="teble-td-inherit">
                    <table class="table table-bordered rounded mt-3 ">
                        <tbody>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Fuel Tank Capacity</p>
                                        <p className="pb-0 mb-0">{data?.fuelcharging?.fuel_tank_capacity}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Electric Range (for electric vehicles)</p>
                                        <p className="pb-0 mb-0">{data?.fuelcharging?.electric_range}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Charging Time (for electric vehicles)</p>
                                        <p className="pb-0 mb-0">{data?.fuelcharging?.charging_time}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Fuel Type</p>
                                        <p className="pb-0 mb-0">{data?.fuelcharging?.fuel_type}</p>
                                    </div>
                                </td>
                            </tr>


                        </tbody>
                    </table>
                </div> */}
                <div className="mt-3">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Fuel Tank Capacity</p>
                                    <p className="mb-0">{data?.fuelcharging?.fuel_tank_capacity}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Electric Range (for electric vehicles)</p>
                                    <p className="mb-0">{data?.fuelcharging?.electric_range}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Charging Time (for electric vehicles)</p>
                                    <p className="mb-0">{data?.fuelcharging?.charging_time}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Fuel Type</p>
                                    <p className="mb-0">{data?.fuelcharging?.fuel_type}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="title-wrapper d-flex mb-30 mt-4">
                    <h4 class="mb-0 flex-shrink-0">Warranty & Service
                    </h4>
                    <span class="spacer align-self-end ms-3"></span>
                </div>
                {/* <div style={{ overflow: 'scroll' }} className="teble-td-inherit">
                    <table class="table table-bordered rounded mt-3 ">
                        <tbody >
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Warranty</p>
                                        <p className="pb-0 mb-0">{data?.warrantyservice?.warranty}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Service Intervals</p>
                                        <p className="pb-0 mb-0">{data?.warrantyservice?.service_intervals}</p>
                                    </div>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div> */}
                <div className="mt-3">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Warranty</p>
                                    <p className="mb-0">{data?.warrantyservice?.warranty}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Service Intervals</p>
                                    <p className="mb-0">{data?.warrantyservice?.service_intervals}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="title-wrapper d-flex mb-30 mt-4">
                    <h4 class="mb-0 flex-shrink-0">Additional Features
                    </h4>
                    <span class="spacer align-self-end ms-3"></span>
                </div>
                {/* <div style={{ overflow: 'scroll' }} className="teble-td-inherit">
                    <table class="table table-bordered rounded mt-3 ">
                        <tbody>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Performance Enhancements</p>
                                        <p className="pb-0 mb-0">{data?.additionalfeature?.performance_enhancements}</p>
                                    </div>
                                </td>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Customizations</p>
                                        <p className="pb-0 mb-0">{data?.additionalfeature?.customizations}</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p style={{ color: 'gray' }} className="pb-0 mb-0">Special Editions</p>
                                        <p className="pb-0 mb-0">{data?.additionalfeature?.special_editions}</p>
                                    </div>
                                </td>

                            </tr>

                        </tbody>
                    </table>
                </div> */}
                <div className="mt-3">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Performance Enhancements</p>
                                    <p className="mb-0">{data?.additionalfeature?.performance_enhancements}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Customizations</p>
                                    <p className="mb-0">{data?.additionalfeature?.customizations}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="border rounded p-3 h-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <p className="mb-0 text-muted">Special Editions</p>
                                    <p className="mb-0">{data?.additionalfeature?.special_editions}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-4 d-flex justify-content-between text-end">
                    <BookingModal ProductDetail={data} />
                    <h3>Price : {data?.price_range}</h3>
                </div>
            </div>
        </div>
    )
}

export default VariantDetail;